import { useState, useEffect } from "react";

import { Grid, Typography, Box, makeStyles } from "@material-ui/core";

import { Parameters } from "./Parameters.js";
import { COLORS } from "../../../../theme/colors";
import { ShaDowBox } from "../../../../components/boxes";
import { parametersData, portfolioChartData } from "../../sample";
import { PortfolioFinanceOutcomes } from "./PortfolioFinanceOutcomes";

import { getData, api } from "../../../../services/api";
import { noiEndPoints } from "../../../../services/apiEndPoints";
import useDebounce from "../../../../hooks/useDebounce";

const useStyles = makeStyles((theme) => ({
  title: {
    display: "flex",
    alignItems: "center",
    marginTop: theme.spacing(3.75),
    marginBottom: theme.spacing(2.5),
  },
  rightGrid: {
    borderLeft: "1px solid rgba(0, 0, 0, 0.25)",
    padding: theme.spacing(3),
  },
}));

export const SensitivityAnalysisTab = () => {
  const classes = useStyles();
  const [sensitivityParameter, setSensitivityParameter] = useState(
    JSON.parse(JSON.stringify(parametersData))
  );
  const [sensitivityChartData, setSensitivityChartData] = useState(
    JSON.parse(JSON.stringify(portfolioChartData))
  );
  const [isSliderTriggered, setSliderTrigger] = useState(false);

  const debounce = useDebounce(isSliderTriggered);

  useEffect(() => {
    getData(noiEndPoints.SENSITIVITY_INITIALS, setSensitivityValues);
  }, []);

  useEffect(() => {
    if (isSliderTriggered) {
      const payload = {};
      const tempData = JSON.parse(JSON.stringify(sensitivityParameter));
      tempData.map((item) => {
        item?.sliders.map((val) => {
          payload[val.key] = +val.value;
        });
      });
      getChartData(payload);
      setSliderTrigger(false);
    }
  }, [debounce]);

  const getChartData = (sliderValues) => {
    const {
      sold_electricity_margin,
      purchased_electricity_margin,
      digitalization_impact,
      gas_prices,
      physical_vacancy_rate,
      economic_vacancy_rate,
      unconnected_tenants,
      installed_batteries,
      installed_ev,
      installed_solar,
      installed_new,
    } = sliderValues;

    api
      .get(noiEndPoints.SENSITIVITY_CALCULATIONS, {
        params: {
          sold_electricity_margin,
          purchased_electricity_margin,
          digitalization_impact,
          gas_prices,
          physical_vacancy_rate,
          economic_vacancy_rate,
          unconnected_tenants,
          installed_batteries,
          installed_ev,
          installed_solar,
          installed_new,
        },
      })
      .then((res) => {
        const response = res?.data;
        if (response) {
          const sensitivityData = sensitivityChartData.map((val) => {
            const { now: before, revised } = response[val.type];
            return {
              ...val,
              data: [{ before }, { revised }],
            };
          });
          setSensitivityChartData(sensitivityData);
        }
      });
  };

  const setSensitivityValues = (value) => {
    const temp = [...JSON.parse(JSON.stringify(sensitivityParameter))];
    const updatedData = temp.map((val) => {
      const updatedSliderValues = val.sliders.map((params) => {
        if (!value[params.key]) return params;
        return {
          ...params,
          value: value[params.key].toFixed(0),
          defaultValue: value[params.key].toFixed(0),
        };
      });
      return {
        ...val,
        sliders: updatedSliderValues,
      };
    });

    getChartData(value);
    setSensitivityParameter(JSON.parse(JSON.stringify(updatedData)));
  };

  return (
    <Box>
      <Box className={classes.title}>
        <Typography style={{ fontWeight: 700, marginRight: 2 }}>
          SENSITIVITY ANALYSIS -
        </Typography>
        <Typography style={{ color: COLORS.darks[0][50] }}>
          Drag or Insert New Parameters To View Revised Values
        </Typography>
      </Box>
      <ShaDowBox>
        <Grid container>
          <Grid item sm={3}>
            <Parameters
              data={sensitivityParameter}
              setData={setSensitivityParameter}
              isSliderTriggered={isSliderTriggered}
              setSliderTrigger={setSliderTrigger}
            />
          </Grid>
          <Grid item sm={9} className={classes.rightGrid}>
            <PortfolioFinanceOutcomes data={sensitivityChartData} />
          </Grid>
        </Grid>
      </ShaDowBox>
    </Box>
  );
};
